import PasswordForm from './PasswordForm'

export default PasswordForm



// WEBPACK FOOTER //
// ./src/views/Settings/components/PasswordForm/index.js